import React from 'react';

import { useAppSelector } from '@/redux/store';

import WithDrawInfo from './WithdrawInfo';
import WithDrawTransaction from './WithDrawTransaction';

import css from './style.module.scss';

const WithdrawModal: React.FC = () => {
  const currencyExchangedShown = useAppSelector(
    (state) => state.user.extendedInfo?.currencyExchangedShown,
  );

  return (
    <div className={css.withdrawModal}>
      {currencyExchangedShown ? <WithDrawTransaction /> : <WithDrawInfo />}
    </div>
  );
};

export default WithdrawModal;
